export const enum EmailRecipients {
  NOTIFICATION = 'notification@leedpulse.io',
  SUPPORT_LEEDFLOW = 'support@leedflow.com',
  DEVELOPER = 'dev@leedpulse.io',
  JOEY = 'joey@leedpulse.com',
  JOEY_BRONNER = 'joeybronner@gmail.com',
  SULLIVAN = 'sullivan@leedpulse.com',
  MARGAUX = 'margaux@leedpulse.com',
  AXEL = 'axel@leedpulse.com',
  AXEL_R = 'axel.r@leedpulse.com',
  ROMAIN = 'romain@leedpulse.com',
  JORDAN = 'jordan@leedflow.com',
  BRIANCHARLESDEV = 'briancharlesdev@gmail.com',
  JOSCELYN = 'joscelyn@leedpulse.com',
  ANTHONY = 'anthony@leedflow.com',
  PRODUIT_FEEDBACK_CUST = 'produit-feedback-cust-aaaaqnhord6iplwsm254lw6qcu@leedpulse.slack.com',
  CLIENTS_SEPTEO = 'clients-septeo-aaaaqqs7dqyzhdlju6qx5gfisy@leedpulse.slack.com',
  CORENTIN = 'corentin@leedpulse.com',
}
